import { lazy } from "react";
import Diversity3OutlinedIcon from "@mui/icons-material/Diversity3Outlined";

import { Navigate } from "react-router-dom";

const Team = lazy(() => import("../components/team"));
const Dashboard = lazy(() => import("../components/dashboard"));
const Process = lazy(() => import("../components/process"));
const CostCenter = lazy(() => import("../components/costcenter"));
const TeamAnnouncementCreate = lazy(() => import("../components/announcement/components/teamAnnouncementCreate"));
const TeamAnnouncementView = lazy(() => import("../components/announcement/components/teamAnnouncementView"));

const TeamRoutes = [
  {
    icon: Diversity3OutlinedIcon,
    name: "Team",
    link: "/team-management",
    path: "team-management",
    index: 18,
    element: <Dashboard />,
    permission: "Team-Read",
    superAdminView: false,
  },
  {
    path: "team-management/team/create",
    element: <Team />,
    index: 7,
  },
  {
    path: "team-management/team/:id",
    element: <Team />,
    index: 8,
  },
  {
    path: "team-management/process/create",
    element: <Process />,
    index: 9,
  },
  {
    path: "team-management/process/:id",
    element: <Process />,
    index: 10,
  },
  {
    path: "team-management/costcenter/create",
    element: <CostCenter />,
    index: 11,
  },
  {
    path: "team-management/costcenter/:id",
    element: <CostCenter />,
    index: 12,
  },
  {
    path: "team-management/team/:teamID/announcement-create",
    element: <TeamAnnouncementCreate />,
  },
  {
    path: "team-management/team/:teamID/announcement/:id",
    element: <TeamAnnouncementCreate />,
  },
  {
    path: "team-management/team/:teamID/view/:id",
    element: <TeamAnnouncementView />,
  },
  {
  path: "team-management/*",
  element: <Navigate to="/team-management" replace />,
  },
  {
    path: "",
    element: <Navigate to="team-management" replace />,
  },
];

export default TeamRoutes;
